import { FitBoundsOptions } from 'maplibre-gl'

export const PROTOMAPS_BASE_URL =
    'https://api.protomaps.com/styles/v2/' as const
export const PROTOMAPS_API_KEY = 'ddd2bebf9ab6fc37' as const
export const DEFAULT_FIT_BOUNDS_OPTIONS: FitBoundsOptions = {
    duration: 0,
    padding: {
        top: 50,
        bottom: 50 + 70,
        left: 50,
        right: 50,
    },
}
